// import { motion } from "framer-motion";
// import mapDots from "../assets/world-dots.png";
// import { Globe2, Route } from "lucide-react";

// type Node = { x: number; y: number; color: "orange" | "pink" | "gold" };

// const nodes: Node[] = [
//   { x: 22, y: 38, color: "orange" }, // North America
//   { x: 30, y: 62, color: "pink" },   // South America
//   { x: 52, y: 42, color: "gold" },   // Europe
//   { x: 60, y: 58, color: "orange" }, // Africa
//   { x: 72, y: 46, color: "pink" },   // Asia
//   { x: 86, y: 72, color: "gold" },   // Australia
// ];

// const routes = [
//   // Paths are in percent-based coordinates for easy responsiveness
//   "M22,38 C35,28 42,30 52,42", // NA -> EU
//   "M52,42 C60,44 66,44 72,46", // EU -> Asia
//   "M52,42 C55,52 56,55 60,58", // EU -> Africa
//   "M72,46 C78,54 82,60 86,72", // Asia -> Australia
// ];

// const colorFor = (c: Node["color"]) => {
//   if (c === "orange") return "#F47C20";
//   if (c === "pink") return "#E83E6F";
//   return "#C9A227";
// };

// export default function ShippingAcross() {
//   return (
//     <section className="relative overflow-hidden bg-[#0F1C24] text-white py-16 md:py-24">
//       {/* Ambient brand glows */}
//       <div className="pointer-events-none absolute -top-28 -left-28 h-80 w-80 rounded-full blur-3xl opacity-20 bg-[#F47C20]" />
//       <div className="pointer-events-none absolute -bottom-28 -right-28 h-96 w-96 rounded-full blur-3xl opacity-20 bg-[#E83E6F]" />

//       <div className="max-w-7xl mx-auto px-6 md:px-8">
//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
//           {/* LEFT: Content */}
//           <motion.div
//             initial={{ opacity: 0, y: 16 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true, amount: 0.25 }}
//             transition={{ duration: 0.6 }}
//             className="lg:col-span-5"
//           >
//             <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 backdrop-blur">
//               <Route size={16} className="text-white/80" />
//               <span className="text-xs tracking-[0.22em] uppercase text-white/80">
//                 Global Export Network
//               </span>
//             </div>

//             <h2 className="mt-6 text-4xl md:text-5xl font-extrabold leading-tight">
//               Shipping Across{" "}
//               <span className="bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent">
//                 100+ Countries
//               </span>
//             </h2>

//             <p className="mt-5 text-base md:text-lg text-white/75 leading-relaxed">
//               Shipping premium dietary supplements to 100+ countries with
//               reliability, efficiency, and adherence to the highest global
//               quality standards.
//             </p>

//             <div className="mt-8 flex flex-wrap gap-3 text-xs text-white/70">
//               {["Export-ready packaging", "Documentation support", "Secure logistics", "On-time dispatch"].map(
//                 (t) => (
//                   <div
//                     key={t}
//                     className="rounded-full border border-white/10 bg-white/5 px-4 py-2 backdrop-blur"
//                   >
//                     {t}
//                   </div>
//                 )
//               )}
//             </div>

//             <div className="mt-10 flex items-center gap-4">
//               <motion.a
//                 whileHover={{ y: -2 }}
//                 whileTap={{ scale: 0.98 }}
//                 href="/contact"
//                 className="inline-flex items-center justify-center rounded-md px-6 py-3 text-sm font-semibold
//                            bg-gradient-to-r from-[#F47C20] to-[#E83E6F] shadow-lg shadow-black/25"
//               >
//                 Request Shipping Quote
//               </motion.a>

//               <div className="flex items-center gap-2 text-white/70 text-sm">
//                 <Globe2 size={18} className="text-[#C9A227]" />
//                 Trusted Worldwide
//               </div>
//             </div>
//           </motion.div>

//           {/* RIGHT: Map + animated connectivity */}
//           <motion.div
//             initial={{ opacity: 0, y: 16 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true, amount: 0.25 }}
//             transition={{ duration: 0.6, delay: 0.05 }}
//             className="lg:col-span-7"
//           >
//             <div className="relative rounded-2xl border border-white/10 bg-white/5 backdrop-blur p-4 md:p-6 overflow-hidden">
//               {/* Map image */}
//               <img
//                 src={mapDots}
//                 alt="Global shipping map"
//                 className="w-full h-[320px] md:h-[380px] object-contain opacity-90"
//                 draggable={false}
//               />

//               {/* Overlay: routes & nodes (percent-based) */}
//               <div className="absolute inset-0">
//                 <svg
//                   viewBox="0 0 100 100"
//                   preserveAspectRatio="none"
//                   className="absolute inset-0 h-full w-full"
//                 >
//                   {/* Routes */}
//                   {routes.map((d, idx) => (
//                     <g key={idx}>
//                       {/* base faint line */}
//                       <path
//                         d={d}
//                         fill="none"
//                         stroke="rgba(255,255,255,0.08)"
//                         strokeWidth="0.5"
//                       />
//                       {/* animated gradient line */}
//                       <motion.path
//                         d={d}
//                         fill="none"
//                         stroke={idx % 2 === 0 ? "#F47C20" : "#E83E6F"}
//                         strokeWidth="0.7"
//                         strokeLinecap="round"
//                         strokeDasharray="2 2.2"
//                         initial={{ pathLength: 0, opacity: 0.2 }}
//                         whileInView={{ pathLength: 1, opacity: 0.9 }}
//                         viewport={{ once: true }}
//                         transition={{ duration: 1.4, ease: "easeOut", delay: 0.2 + idx * 0.12 }}
//                       />
//                       {/* moving “spark” along the route */}
//                       <motion.circle
//                         r="0.7"
//                         fill="#C9A227"
//                         initial={{ opacity: 0 }}
//                         whileInView={{ opacity: 1 }}
//                         viewport={{ once: true }}
//                       >
//                         <motion.animateMotion
//                           dur={`${3.2 + idx * 0.4}s`}
//                           repeatCount="indefinite"
//                           path={d}
//                         />
//                       </motion.circle>
//                     </g>
//                   ))}
//                 </svg>

//                 {/* Pulsing nodes */}
//                 {nodes.map((n, i) => (
//                   <motion.div
//                     key={i}
//                     className="absolute"
//                     style={{
//                       left: `${n.x}%`,
//                       top: `${n.y}%`,
//                       transform: "translate(-50%, -50%)",
//                     }}
//                   >
//                     {/* pulse ring */}
//                     <motion.div
//                       className="absolute -inset-3 rounded-full"
//                       style={{ border: `1px solid ${colorFor(n.color)}55` }}
//                       animate={{ scale: [1, 1.6, 1], opacity: [0.25, 0.0, 0.25] }}
//                       transition={{ duration: 2.6, repeat: Infinity, delay: i * 0.2 }}
//                     />
//                     {/* dot */}
//                     <div
//                       className="h-2.5 w-2.5 rounded-full shadow-[0_0_18px_rgba(255,255,255,0.18)]"
//                       style={{
//                         background: `linear-gradient(90deg, ${colorFor(n.color)}, #ffffff)`,
//                       }}
//                     />
//                   </motion.div>
//                 ))}

//                 {/* subtle diagonal sheen */}
//                 <motion.div
//                   className="pointer-events-none absolute -left-1/2 top-0 h-full w-1/2 rotate-12 bg-gradient-to-r from-transparent via-white/8 to-transparent"
//                   animate={{ x: ["-30%", "160%"] }}
//                   transition={{ duration: 5.5, repeat: Infinity, ease: "linear" }}
//                 />
//               </div>

//               {/* Bottom mini info bar */}
//               <div className="mt-5 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
//                 <div className="text-sm text-white/70">
//                   <span className="font-semibold text-white">100+ Countries</span>{" "}
//                   • Export documentation • Secure logistics
//                 </div>

//                 <div className="text-xs text-white/60">
//                   Routes shown for illustration
//                 </div>
//               </div>
//             </div>
//           </motion.div>
//         </div>
//       </div>
//     </section>
//   );
// }


// import React, { useEffect, useMemo, useRef } from "react";
// import { motion, useAnimationFrame, useMotionValue } from "framer-motion";
// import { ReactComponent as WorldMap } from "../assets/world-dots.svg";
// import { Route } from "lucide-react";

// /**
//  * ViewBox coordinates used for overlay SVG:
//  * We'll use viewBox="0 0 100 50" and draw routes in that space.
//  * The overlay svg stretches to the map container, so it stays responsive.
//  */

// type RouteDef = {
//   id: string;
//   d: string; // SVG path in 0..100 x 0..50 coordinate space
//   color: string;
//   speed: number; // higher = faster
//   dash: string; // stroke dasharray
//   dotColor: string;
//   dots: number; // how many moving dots on this route
// };

// type NodeDef = {
//   id: string;
//   x: number; // 0..100
//   y: number; // 0..50
//   color: string;
// };

// const BRAND = {
//   orange: "#F47C20",
//   pink: "#E83E6F",
//   gold: "#C9A227",
// };

// const routes: RouteDef[] = [
//   // USA -> Europe
//   {
//     id: "na-eu",
//     d: "M18,18 C30,8 44,10 54,16",
//     color: "rgba(244,124,32,0.85)",
//     dash: "3 3",
//     speed: 0.09,
//     dotColor: BRAND.gold,
//     dots: 2,
//   },
//   // Europe -> India/Asia
//   {
//     id: "eu-asia",
//     d: "M54,16 C63,18 70,18 78,20",
//     color: "rgba(232,62,111,0.85)",
//     dash: "3 3",
//     speed: 0.08,
//     dotColor: BRAND.orange,
//     dots: 2,
//   },
//   // Europe -> Africa
//   {
//     id: "eu-af",
//     d: "M54,16 C56,22 57,26 58,31",
//     color: "rgba(201,162,39,0.80)",
//     dash: "2.5 3.2",
//     speed: 0.075,
//     dotColor: BRAND.pink,
//     dots: 1,
//   },
//   // Asia -> Australia
//   {
//     id: "asia-au",
//     d: "M78,20 C84,26 88,32 90,38",
//     color: "rgba(244,124,32,0.75)",
//     dash: "3 3",
//     speed: 0.07,
//     dotColor: BRAND.gold,
//     dots: 1,
//   },
// ];

// const nodes: NodeDef[] = [
//   { id: "usa", x: 18, y: 18, color: BRAND.orange },
//   { id: "eu", x: 54, y: 16, color: BRAND.gold },
//   { id: "india", x: 72, y: 20, color: BRAND.pink },
//   { id: "africa", x: 58, y: 31, color: BRAND.orange },
//   { id: "aus", x: 90, y: 38, color: BRAND.gold },
// ];

// /** Moving dot along a path using getPointAtLength (works everywhere) */
// function MovingDot({
//   pathRef,
//   offset = 0,
//   speed = 0.08,
//   color = BRAND.gold,
//   size = 1.1,
// }: {
//  pathRef: React.RefObject<SVGPathElement | null>;
//   offset?: number; // 0..1 initial phase
//   speed?: number; // rate per second
//   color?: string;
//   size?: number; // circle radius in viewBox units
// }) {
//   const cx = useMotionValue(0);
//   const cy = useMotionValue(0);

//   const lengthRef = useRef<number>(0);

//   useEffect(() => {
//     if (!pathRef.current) return;
//     lengthRef.current = pathRef.current.getTotalLength();
//   }, [pathRef]);

//   useAnimationFrame((t) => {
//     const path = pathRef.current;
//     if (!path) return;
//     const L = lengthRef.current || path.getTotalLength();

//     // time in seconds
//     const time = t / 1000;

//     // progress loops 0..1
//     const progress = (offset + time * speed) % 1;

//     const p = path.getPointAtLength(progress * L);
//     cx.set(p.x);
//     cy.set(p.y);
//   });

//   return (
//     <>
//       {/* glow */}
//       <motion.circle
//         r={size * 2.4}
//         fill={color}
//         opacity={0.12}
//         style={{ cx, cy }}
//       />
//       {/* main dot */}
//       <motion.circle
//         r={size}
//         fill={color}
//         style={{ cx, cy }}
//       />
//     </>
//   );
// }

// export default function ShippingAcross() {
//   // Create stable refs for each route path
//   const pathRefs = useMemo(() => {
//   const obj: Record<string, React.RefObject<SVGPathElement | null>> = {};
//   routes.forEach((r) => {
//     obj[r.id] = React.createRef<SVGPathElement>();
//   });
//   return obj;
// }, []);
// //   const pathRefs = useMemo(() => {
// //     const obj: Record<string, React.RefObject<SVGPathElement>> = {};
// //     routes.forEach((r) => (obj[r.id] = React.createRef<SVGPathElement>()));
// //     return obj;
// //   }, []);

//   return (
//     <section className="relative overflow-hidden bg-[#0F1C24] text-white py-20 md:py-28">
//       {/* Brand glows */}
//       <div className="pointer-events-none absolute -top-32 -left-32 h-96 w-96 rounded-full blur-3xl opacity-20 bg-[#F47C20]" />
//       <div className="pointer-events-none absolute -bottom-36 -right-36 h-[520px] w-[520px] rounded-full blur-3xl opacity-20 bg-[#E83E6F]" />

//       <div className="max-w-7xl mx-auto px-6 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
//         {/* LEFT CONTENT */}
//         <motion.div
//           initial={{ opacity: 0, y: 16 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.25 }}
//           transition={{ duration: 0.6 }}
//           className="lg:col-span-5"
//         >
//           <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 backdrop-blur">
//             <Route size={16} className="text-white/80" />
//             <span className="text-xs tracking-[0.22em] uppercase text-white/80">
//               Global Connectivity
//             </span>
//           </div>

//           <h2 className="mt-6 text-4xl md:text-5xl font-extrabold leading-tight">
//             Shipping Across{" "}
//             <span className="bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent">
//               100+ Countries
//             </span>
//           </h2>

//           <p className="mt-5 text-base md:text-lg text-white/75 leading-relaxed">
//             Shipping premium dietary supplements to 100+ countries with reliability,
//             efficiency, and adherence to the highest global quality standards.
//           </p>

//           <div className="mt-9 flex flex-wrap gap-3 text-xs text-white/70">
//             {["Export-ready", "Fast dispatch", "Documentation", "Secure logistics"].map((t) => (
//               <span
//                 key={t}
//                 className="rounded-full border border-white/10 bg-white/5 px-4 py-2 backdrop-blur"
//               >
//                 {t}
//               </span>
//             ))}
//           </div>
//         </motion.div>

//         {/* RIGHT MAP + CONNECTIVITY */}
//         <motion.div
//           initial={{ opacity: 0, y: 16 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.25 }}
//           transition={{ duration: 0.6, delay: 0.05 }}
//           className="lg:col-span-7"
//         >
//           <div className="relative rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl p-5 md:p-7 overflow-hidden">
//             {/* subtle inner glow */}
//             <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-[#F47C20]/10 via-transparent to-[#E83E6F]/10" />

//             {/* Map */}
//             <div className="relative">
//               <WorldMap className="w-full h-[320px] md:h-[400px] opacity-80" />

//               {/* Overlay connectivity layer */}
//               <svg
//                 viewBox="0 0 100 50"
//                 preserveAspectRatio="none"
//                 className="absolute inset-0 w-full h-full"
//               >
//                 {/* draw routes */}
//                 {routes.map((r, idx) => (
//                   <g key={r.id}>
//                     {/* faint base line */}
//                     <path
//                       d={r.d}
//                       fill="none"
//                       stroke="rgba(255,255,255,0.10)"
//                       strokeWidth="0.55"
//                     />

//                     {/* glowing moving dashed line */}
//                     <motion.path
//                       ref={pathRefs[r.id]}
//                       d={r.d}
//                       fill="none"
//                       stroke={r.color}
//                       strokeWidth="0.8"
//                       strokeLinecap="round"
//                       strokeDasharray={r.dash}
//                       initial={{ opacity: 0, pathLength: 0 }}
//                       whileInView={{ opacity: 1, pathLength: 1 }}
//                       viewport={{ once: true }}
//                       transition={{ duration: 1.2, delay: 0.15 + idx * 0.08 }}
//                       animate={{ strokeDashoffset: [0, -24] }}
//                       style={{ filter: "drop-shadow(0 0 10px rgba(255,255,255,0.06))" }}
//                       // Dash offset animation:
//                       // keep it running even after reveal
//                       // @ts-ignore (Framer supports this at runtime)
//                       transition={{
//                         duration: 1.2,
//                         delay: 0.15 + idx * 0.08,
//                       }}
//                     />
//                   </g>
//                 ))}

//                 {/* pulsing nodes */}
//                 {nodes.map((n, i) => (
//                   <g key={n.id}>
//                     <motion.circle
//                       cx={n.x}
//                       cy={n.y}
//                       r={2.8}
//                       fill={n.color}
//                       opacity={0.12}
//                       animate={{ scale: [1, 1.5, 1], opacity: [0.12, 0.0, 0.12] }}
//                       transition={{ duration: 2.6, repeat: Infinity, delay: i * 0.2 }}
//                     />
//                     <circle cx={n.x} cy={n.y} r={1.05} fill={n.color} />
//                     <circle cx={n.x} cy={n.y} r={0.45} fill="#ffffff" opacity={0.85} />
//                   </g>
//                 ))}

//                 {/* moving “signals” along each route */}
//                 {routes.map((r, idx) => {
//                   const pr = pathRefs[r.id];
//                   return (
//                     <g key={`${r.id}-dots`}>
//                       {Array.from({ length: r.dots }).map((_, j) => (
//                         <MovingDot
//                           key={`${r.id}-${j}`}
//                           pathRef={pr}
//                           offset={(j / r.dots) + idx * 0.12}
//                           speed={r.speed}
//                           color={r.dotColor}
//                           size={1.0}
//                         />
//                       ))}
//                     </g>
//                   );
//                 })}
//               </svg>
//             </div>

//             {/* Bottom info strip */}
//             <div className="mt-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
//               <div className="text-sm text-white/75">
//                 <span className="font-semibold text-white">100+ Countries</span>{" "}
//                 • Live connectivity illustration
//               </div>
//               <div className="text-xs text-white/55">
//                 Routes are representative
//               </div>
//             </div>
//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// }

import { motion } from "framer-motion";
import { ReactComponent as WorldMap } from "../assets/world-dots.svg";
import { Globe2, Route } from "lucide-react";

export default function ShippingAcross() {
  return (
    <section className="relative overflow-hidden bg-[#0F1C24] text-white py-20 md:py-28">

      {/* Soft Brand Glows */}
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-[#F47C20]/15 rounded-full blur-3xl" />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-[#E83E6F]/15 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

        {/* LEFT CONTENT */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur">
            <Route size={16} />
            <span className="text-xs uppercase tracking-[0.25em] text-white/70">
              Global Shipping Network
            </span>
          </div>

          <h2 className="mt-6 text-4xl md:text-5xl font-extrabold leading-tight">
            Shipping Across{" "}
            <span className="bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent">
              100+ Countries
            </span>
          </h2>

          <p className="mt-6 text-lg text-white/75 leading-relaxed">
            Shipping premium dietary supplements to 100+ countries with reliability,
            efficiency, and adherence to the highest global quality standards.
          </p>

          <div className="mt-8 flex items-center gap-3 text-sm text-white/70">
            <Globe2 size={18} className="text-[#C9A227]" />
            Trusted Worldwide Distribution
          </div>
        </motion.div>

        {/* RIGHT MAP SECTION */}
        <div className="relative">

          {/* Glass Container */}
          <div className="relative rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl p-6 overflow-hidden">

            {/* SVG MAP */}
            <div className="relative">
              <WorldMap className="w-full h-[360px] opacity-80" />

              {/* Overlay SVG for animated routes */}
              <svg
                viewBox="0 0 100 50"
                className="absolute inset-0 w-full h-full"
                preserveAspectRatio="none"
              >
                {/* Animated Route 1 */}
                <motion.path
                  d="M20,25 C35,10 50,15 60,20"
                  stroke="#F47C20"
                  strokeWidth="0.6"
                  fill="none"
                  strokeDasharray="3 3"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{ duration: 2 }}
                />

                {/* Animated Route 2 */}
                <motion.path
                  d="M60,20 C70,22 80,30 85,35"
                  stroke="#E83E6F"
                  strokeWidth="0.6"
                  fill="none"
                  strokeDasharray="3 3"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{ duration: 2.5 }}
                />

                {/* Moving shipment dot */}
                <motion.circle
                  r="1"
                  fill="#C9A227"
                >
                  <animateMotion
                    dur="4s"
                    repeatCount="indefinite"
                    path="M20,25 C35,10 50,15 60,20"
                  />
                </motion.circle>
              </svg>
            </div>

            {/* Floating Stat Cards */}
            <motion.div
              animate={{ y: [0, -12, 0] }}
              transition={{ repeat: Infinity, duration: 6 }}
              className="absolute top-6 right-6 bg-white text-[#1B1B1B] px-5 py-4 rounded-xl shadow-xl"
            >
              <p className="text-2xl font-bold text-[#C62828]">100+</p>
              <p className="text-xs">Countries Served</p>
            </motion.div>

            <motion.div
              animate={{ y: [0, 12, 0] }}
              transition={{ repeat: Infinity, duration: 5 }}
              className="absolute bottom-6 left-6 bg-white text-[#1B1B1B] px-5 py-4 rounded-xl shadow-xl"
            >
              <p className="text-2xl font-bold text-[#F47C20]">On-Time</p>
              <p className="text-xs">Global Dispatch</p>
            </motion.div>

          </div>
        </div>

      </div>
    </section>
  );
}